import { toast } from 'sonner';
import { createMutationHook } from '@/hooks/lib/createMutationHook';
import { apiPost, operationsClient } from '@/lib/api';
import { settingsEndpoints } from '@/lib/api/endpoints';
import { settingsKeys } from '@/lib/queryKeys';
import type { JobType, CreateJobTypeDto } from '@/types/settings';

export const useCreateJobType = createMutationHook<JobType, CreateJobTypeDto>({
  mutationFn: (dto) =>
    apiPost<JobType, CreateJobTypeDto>(operationsClient, settingsEndpoints.jobTypes(), dto),
  onSuccess: (_data, _variables, queryClient) => {
    void queryClient.invalidateQueries({ queryKey: settingsKeys.jobTypes() });
    toast.success('Job type created');
  },
});
